import { queryParamsSelector } from 'shared/app/state/selectors/routes';
import { oauthAuthorizeStatusSelector } from './selectors';
import {
  OAUTH_AUTHORIZE_STATUS,
  OAUTH_AUTHORIZE_STATUS_ERROR,
  OAUTH_AUTHORIZE_STATUS_SUCCESS,
  OAUTH_AUTHORIZE_CONFIRM,
  OAUTH_AUTHORIZE_CONFIRM_ERROR,
  OAUTH_AUTHORIZE_CONFIRM_SUCCESS,
} from './actions';

export const checkOauthAuthorizeStatus =
  () =>
  (dispatch, getState, { apiFetch }) => {
    const reduxState = getState();
    const queryParams = queryParamsSelector(reduxState);

    dispatch({ type: OAUTH_AUTHORIZE_STATUS });

    const {
      client_id: clientId,
      redirect_uri: requestRedirectUri,
      response_type: responseType,
      scope,
      state,
    } = queryParams || {};

    if (!queryParams || !clientId || !responseType) {
      const error = new Error(
        'Authorization details are missing or incomplete.'
      );
      dispatch({
        error,
        type: OAUTH_AUTHORIZE_STATUS_ERROR,
      });
      return null;
    }

    const body = {
      clientId,
      requestRedirectUri,
      responseType,
      scope,
      state,
    };

    const url = '/apiproxy/v1/oauth/authorize/status';

    return apiFetch(url, { method: 'POST', body })
      .then((payload) => {
        dispatch({
          type: OAUTH_AUTHORIZE_STATUS_SUCCESS,
          payload,
        });
        return payload;
      })
      .catch((error) => {
        dispatch({
          error,
          type: OAUTH_AUTHORIZE_STATUS_ERROR,
        });
      });
  };

export const confirmOauthAuthorize =
  () =>
  (dispatch, getState, { apiFetch }) => {
    dispatch({ type: OAUTH_AUTHORIZE_CONFIRM });

    const reduxState = getState();
    const authorizationDetails = oauthAuthorizeStatusSelector(reduxState)?.data;
    const { clientId, responseType, redirectUri, scope, state } =
      authorizationDetails || {};

    if (!authorizationDetails || !clientId || !responseType) {
      const error = new Error(
        'Authorization details are missing or incomplete.'
      );
      dispatch({
        error,
        type: OAUTH_AUTHORIZE_CONFIRM_ERROR,
      });
      throw error;
    }

    const body = {
      clientId,
      responseType,
      redirectUri,
      scope,
      state,
    };

    const url = '/apiproxy/v1/oauth/authorize';

    return apiFetch(url, { method: 'POST', body })
      .then((payload) => {
        dispatch({
          type: OAUTH_AUTHORIZE_CONFIRM_SUCCESS,
          payload,
        });
        if (!payload?.redirectUri) {
          throw new Error('Redirect URI is missing in the response.');
        }
        return payload.redirectUri;
      })
      .catch((error) => {
        dispatch({
          error,
          type: OAUTH_AUTHORIZE_CONFIRM_ERROR,
        });
        throw error;
      });
  };
